export const signInPath = "/auth/sign-in";
export const autoSignUpPath = "/auth/auto";
